import React from 'react';
import ParentAuthPage from './ParentAuthPage';
import { ViewPasswordInput } from 'components/ViewInput';
import UserService from 'utils/UserService';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as AuthActions from 'actions/AuthActions';
import * as UiActions from 'actions/UiActions';
import { getErrorByCode } from 'utils/Helper';
import classNames from 'classnames';
import 'css/BrugerinfoPage.css';
import Button from 'ui/Button';
import { detectMobile } from 'utils/UiHelper';
import { browserHistory } from 'react-router';
import { NotificationManager } from 'react-notifications';
/*const PASSWORD = 'password';
const disallowedChars = /[^!&;%\\]/g;
const passwordRegex = /^(([a-z]?)(?=.*[A-Z])(?=.*[0-9]))(?=.{10,})/;

const validatePassword = (value) => {
    let valid = true;

    if (!passwordRegex.test(value)) {
        valid = false;
        setError(
            'Kodeord skal minimum indeholde 1 stort bogstav, 1 tal og 10 tegn'
        );
    }
    if (value.match(disallowedChars)?.length !== value?.length) {
        valid = false;
        setError('Kodeord må ikke indeholde ! & ; \\ %');
    }
};*/

class BrugerinfoPage extends ParentAuthPage {
    fieldsValidator = {};
    fieldsValidator2 = {};

    constructor() {
        super();

        this.state = {
            ...this.state,
            oldPwd: '',
            newPwd: '',
            rptPwd: '',
            showPasswordError: false,
        };
    }

    componentDidMount() {
        this.setPageTitle('Ændre adgangskode');
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!this.props.auth.user && this.props.auth.sessionError) {
            browserHistory.push('/sport/');
            this.props.uiActions.showModal('LOGIN_FIRST');
        }
    }

    checkHandler2(key, fn) {
        this.fieldsValidator2[key] = fn;
    }

    validateFields2() {
        Object.keys(this.fieldsValidator2).map((key) =>
            this.fieldsValidator2[key]()
        );
    }

    valueHandler(key, val) {
        this.setState({ [key]: val });

        if (this.state.successMessage || this.state.errorMessage) {
            this.setState({
                successMessage: null,
                errorMessage: null,
            });
        }
    }

    onClickHandler() {
        this.validateFields2();

        const oldPwd = this.state.oldPwd;
        const newPwd = this.state.newPwd;
        const rptPwd = this.state.rptPwd;

        if (oldPwd && newPwd && rptPwd) {
            if (newPwd.length < 10) {
                this.setState({
                    showPasswordError: true,
                });
            } else {
                this.setState({
                    showPasswordError: false,
                });
                if (newPwd === rptPwd) {
                    UserService.ChangePassword({
                        current: oldPwd,
                        edit: newPwd,
                        confirm: rptPwd,
                    }).then((res) => {
                        if (res.success) {
                            this.setSuccessMessage('Dit kodeord er nu ændret');
                            this.setState({
                                oldPwd: '',
                                newPwd: '',
                                rptPwd: '',
                            });
                        } else {
                            this.setErrorMessage(
                                getErrorByCode(res.errorMessage)
                            );
                        }
                    });
                } else {
                    this.setErrorMessage('Ny kode og gentagelse er ikke ens.');
                }
            }
        }
    }

    render() {
        if (this.props.auth.user) {
            return (
                <React.Fragment>
                    {this.getHeaderView(() => {
                        this.props.uiActions.showModal('USER_MENU');
                    })}
                    <div
                        className={classNames('brugerinfo-page', {
                            mobile: detectMobile(),
                        })}
                    >
                        <div className="header">Ændre din adgangskode</div>
                        <div className="info">
                            Opdatér din adgangskode for Bet25 Sport.{' '}
                            <b>Bemærk</b>, at denne ændring ogsa gælder for
                            Bet25 Casino og Bet25 Heste.
                        </div>

                        {this.state.errorMessage
                            ? this.getErrorView(this.state.errorMessage)
                            : null}
                        {this.state.successMessage
                            ? this.getSuccessView(this.state.successMessage)
                            : null}

                        <div className="fields-container">
                            <div className="current-pass">
                                <ViewPasswordInput
                                    name="oldPwd"
                                    placeholder=""
                                    placeholderLabel="Nuværende adgangskode"
                                    checkHandler={this.checkHandler2.bind(this)}
                                    valueHandler={this.valueHandler.bind(this)}
                                />
                            </div>
                            <div>
                                <ViewPasswordInput
                                    name="newPwd"
                                    placeholder=""
                                    placeholderLabel="Ny adgangskode"
                                    checkHandler={this.checkHandler2.bind(this)}
                                    valueHandler={this.valueHandler.bind(this)}
                                />
                                {this.state.showPasswordError && (
                                    <div className="info red">
                                        Kodeord skal minimum indeholde 10 tegn
                                    </div>
                                )}
                            </div>
                            <div>
                                <ViewPasswordInput
                                    name="rptPwd"
                                    placeholder=""
                                    placeholderLabel="Gentag ny adgangskode"
                                    checkHandler={this.checkHandler2.bind(this)}
                                    valueHandler={this.valueHandler.bind(this)}
                                />
                            </div>
                        </div>
                        <div className="p10">
                            <Button
                                padding="15px 50px"
                                active
                                margin="10px auto"
                                onClick={this.onClickHandler.bind(this)}
                            >
                                Gem ændringer
                            </Button>
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return (
                <div className="brugerinfo-page pb80">
                    {this.getHeaderView(() => {
                        this.props.uiActions.showModal('USER_MENU');
                    })}

                    {this.getErrorView('Du skal først logge ind')}
                </div>
            );
        }
    }
}

function mapStateToProps(state) {
    return { auth: state.auth };
}

function mapDispatchToProps(dispatch) {
    return {
        authActions: bindActionCreators(AuthActions, dispatch),
        uiActions: bindActionCreators(UiActions, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BrugerinfoPage);
